@if (loaded) {
  <app-base-inline-form [header]="props.label" [fields]="buttons" [leftHeader]="true"></app-base-inline-form>
  <!--
    No stateKey: a plan grid's columns are positional (1..Width) and are rebuilt
    whenever the plan is resized, so saving/restoring their state is meaningless -
    and harmful. A saved sort is re-applied by applyColumnState on every load even
    though the columns are no longer sortable, which reordered the shaft rows.
  -->
  <app-grid
    gridCssClass="warp-weft-plan-grid"
    [columnDefs]="columnDefs"
    [rowData]="rowData$ | async"
    [multiSelectCells]="true"
    [showDelete]="false"
    [pagination]="false"
    [filter]="false"
    [sortable]="false"
    [resizable]="false"
  ></app-grid>
  @if (!coordinateCode) {
    <!-- R4 (28 Aug notes): say how many shades the plan runs to, and what the bracket
         rows mean - the colours alone did not read. -->
    <div class="form-explanation">
      <ng-container i18n>Shade rows: {{ shadeSummary }}.</ng-container>
      <ng-container i18n> L1 = level 1 brackets (yellow/green), L2 = level 2 brackets (orange/blue).</ng-container>
    </div>
  }
  @if (showCode) {
    <app-base-form [fields]="fields" [model]="fieldModel"></app-base-form>
  }
}
